import type { SVGProps } from 'react'

const SvgChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.0003 5.41006L5.2903 1.17007C5.38326 1.07634 5.49386 1.00194 5.61572 0.951174C5.73758 0.900406 5.86828 0.874267 6.0003 0.874267C6.13231 0.874267 6.26301 0.900406 6.38487 0.951174C6.50673 1.00194 6.61733 1.07634 6.7103 1.17007L10.9503 5.41007C11.044 5.50303 11.1184 5.61363 11.1692 5.73549C11.22 5.85735 11.2461 5.98805 11.2461 6.12007C11.2461 6.25208 11.22 6.38278 11.1692 6.50464C11.1184 6.6265 11.044 6.7371 10.9503 6.83007C10.7629 7.01632 10.5095 7.12086 10.2453 7.12086C9.98111 7.12086 9.72766 7.01632 9.5403 6.83007L6.0003 3.29007L2.4603 6.83006C2.27403 7.01481 2.02263 7.11896 1.7603 7.12006C1.62869 7.12083 1.49823 7.0956 1.37639 7.04584C1.25455 6.99607 1.14373 6.92275 1.05029 6.83006C0.95322 6.74045 0.874866 6.63248 0.819759 6.51241C0.764652 6.39233 0.733885 6.26252 0.729236 6.13049C0.724587 5.99845 0.746148 5.86681 0.792673 5.74315C0.839198 5.6195 0.909764 5.50629 1.0003 5.41006Z"
      fill={props?.fill ?? '#181818'}
    />
  </svg>
)

export default SvgChevronUp
